module.exports = __webpack_public_path__ + "img/St Lucia.c28d36aa.svg";